module.exports = __webpack_public_path__ + "img/0xaf53d56ff99f1322515e54fdde93ff8b3b7dafd5.6f554504.png";